/**
 * Cross-feature context, so it lives outside `app/features/`: the record peek
 * (`views`) provides it, while the permission gates it switches off belong to
 * `businessObjects`.
 */
import { createContext, type ReactNode, use } from "react";

const ReadOnlySurfaceContext = createContext(false);

/**
 * Marks a subtree as view-only. Every write gate that answers through
 * `useResourcePermissions` reads "denied" inside it, so the record page can be
 * rendered as the read-only peek without each block learning a peek mode.
 */
export const ReadOnlySurface = ({ children }: { children: ReactNode }) => (
  <ReadOnlySurfaceContext value>{children}</ReadOnlySurfaceContext>
);

export const useIsReadOnlySurface = (): boolean => use(ReadOnlySurfaceContext);
